var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center font-semibold text-black",on:{"click":_vm.goToCheckout}},[_c('div',{staticClass:"flex relative mr-2"},[_c('CartIcon',{staticClass:"cart-icon"}),_vm._v(" "),_c('span',{staticClass:"items-count-badge"},[_vm._v(_vm._s(_vm.basketItemsCount))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }